import styles from '../../css/Report.module.css';
//chart
// import Line from '../../component/ChartsLine';
// import Column from '../../component/ChartsColumn';
// import Pie from '../../component/ChartsPie';
// import Area from '../../component/ChartStackedArea';
// import Chart3DColumn from '../../component/Chart3DColumn';
import ChartHistogram from '../../component/ChartHistogram';
import Column2 from '../../component/ChartsColumn2';
import Line3 from '../../component/ChartsLine3';

export default function Component({
	itemData
}) {
	return (
		<div className={styles.resultContainer}>
			<div className={styles.area}>
				<h2>유동인구</h2>
				{/* <p>-</p> */}
				<div className={styles.graphFull}>
					<ChartHistogram chartData={itemData.distance} title={'거리차별 유동인구'} />
				</div>
			</div>
			<div className={styles.area}>
				<div className={styles.graphFull}>
					<Line3 chartData={itemData.age2} title={'연령별 유동인구'} />
				</div>
			</div>
			
			<div className={styles.area}>
				<div className={styles.graphFull}>
					<Column2 chartData={itemData.life} title={'생애주기별 유동인구'} />
				</div>
			</div>
		</div>
	)
}